$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (form.id === 'shipping') {
    const filterShippingMethod = () => {
      const list = $("[data-id='shippingMethodList']");
      const country = form.country().toLowerCase();
      $('.rdblistShippingMethodStep3').show();
      $('.rdblistShippingMethodStep3 input:radio').attr('checked', '');
      $('.rdblistShippingMethodStep3 input:radio').prop('checked', false);

      const shippsToHide = $('.rdblistShippingMethodStep3').filter(() => {
        let notFound = $(this).attr('data-title').toLowerCase().indexOf(country) === -1;

        if (country === 'belgique' && notFound) {
          notFound = $(this).attr('data-title').toLowerCase().indexOf('belgium') === -1;
        }

        return notFound;
      });
      list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');

      shippsToHide.hide();
      OCMSBagStep3.EqualizeShippingMethods();
    };

    filterShippingMethod();
    form.countryField.on('change', filterShippingMethod);
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/melvita-eu.form.js